import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {AgentState} from "./agents.state";
import {agentsFeature} from "./agents.state";
import {AgentsActions, AgentsAPiActions, AgentsChannelActions} from "./agents.actions";
import {AgentModel} from "../models/agent.model";
import {EntitiesFacade} from "../../../commons/angular/classes/entities-facade";
import {Observable, take} from 'rxjs';
import {servicesFeature} from "../../../deliveries/angular/state/services.state";

@Injectable()
export class AgentsFacadeService implements EntitiesFacade<AgentModel> {

  constructor(@Inject(Store) private store: Store<AgentState>) {
  }

  subscribeToChannels(ids?: string[]): void {
    this.store.dispatch(AgentsChannelActions.subscribe({ids: ids}));
  }

  unsubscribeFromChannels(): void {
    this.store.dispatch(AgentsChannelActions.unsubscribe());
  }

  removeByIds(ids: string[]): void {
    throw new Error('Method not implemented.');
  }

  removeAll(): void {
    throw new Error('Method not implemented.');
  }

  setMany(entities: AgentModel[]): void {
    throw new Error('Method not implemented.');
  }

  setOne(entity: AgentModel): void {
    throw new Error('Method not implemented.');
  }

  updateOne(entity: AgentModel): void {
    throw new Error('Method not implemented.');
  }

  updateMany(entities: AgentModel[]): void {
    throw new Error('Method not implemented.');
  }

  selectOne(id: string): Observable<AgentModel> {
    return this.store.select(agentsFeature.selectAgent(id));
  }

  selectAll(): Observable<AgentModel[]> {
    throw new Error('Method not implemented.');
  }

  selectByIds(ids: string[]): Observable<AgentModel[]> {
    throw new Error('Method not implemented.');
  }

  selectIsLoading(): Observable<boolean> {
    throw new Error('Method not implemented.');
  }

  clearStore(): void {
    this.store.dispatch(AgentsActions.clearStore());
  }

  getOne(id: string, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(AgentsAPiActions.getAgent({id: id, isSubscribeToChannel: isSubscribeToChannel}));
  }

  getMany(params?: Object, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(AgentsAPiActions.getAgents({params: params, isSubscribeToChannel: isSubscribeToChannel}));
  }

  getInfiniteScrollEntities(params?: Object, isSubscribeToChannels?: boolean): void {
    this.store.dispatch(AgentsAPiActions.getInfiniteScrollAgents({params: params, isSubscribeToChannel: isSubscribeToChannels}));
  }

  selectInfiniteScrollEntities(): Observable<AgentModel[]> {
    return this.store.select(agentsFeature.selectInfiniteScrollAgents());
  }

  selectInfiniteScrollLoadingState(): Observable<boolean> {
    return this.store.select(agentsFeature.selectIsInfiniteScrollLoading());
  }

  fetchNext(params?: Object, isSubscribeToChannel?: boolean): void {
    this.store.select(agentsFeature.selectCursor()).pipe(take(1)).subscribe((cursor) => {
      if (!!cursor) {
        this.store.dispatch(AgentsAPiActions.getInfiniteScrollAgents({params: params, isSubscribeToChannel: isSubscribeToChannel}));
      }
    })
  }

  createOne(agent: AgentModel): void {
    this.store.dispatch(AgentsAPiActions.createAgent({agent: agent}));
  }

  editOne(id: string, agent: AgentModel): void {
    this.store.dispatch(AgentsAPiActions.updateAgent({id: id, agent: agent}));
  }

  deleteOne(id: string, shouldMask?: boolean): void {
    this.store.dispatch(AgentsAPiActions.deleteAgent({id: id, shouldMask: shouldMask}));
  }


}
